import React, { useContext, useEffect, useState } from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { useAppSelector } from 'store/hook';
import { CommunityType } from 'types/communities';

import SidebarSelectorDropdownListEmptyState from './SidebarSelectorDropdownListEmptyState';
import SidebarSelectorDropdownListItem from './SidebarSelectorDropdownListItem';
import { SELECTOR_ITEM_TYPES } from '../constants';
import { SidebarContext } from '../SidebarContext';
import { SelectorItemDatatype } from '../types';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-x: auto;
  border-top: solid 1px var(--line-gray);

  &.empty {
    border-top: none;
  }
`;

const SidebarSelectorDropdownListUser = () => {
  const { communities, competitors, communityMap } = useAppSelector((state) => state.global);

  const { filterKeyword, filterType } = useContext(SidebarContext);
  const [items, setItems] = useState<SelectorItemDatatype[]>([]);

  useEffect(() => {
    const adjustedCommunities = (communities ?? []).map((item: CommunityType) => ({
      id: item.id,
      type: SELECTOR_ITEM_TYPES.COMMUNITY,
      name: item.comunity_name,
      address: item.address,
      description: item.address,
    }));

    const adjustedCompetitors = (competitors ?? []).map((item: CommunityType) => {
      return {
        id: item.id,
        type: SELECTOR_ITEM_TYPES.COMPETITOR,
        name: item.comunity_name,
        address: item.address,
        description: item.address,
      };
    });

    const allItems = [...adjustedCommunities, ...adjustedCompetitors]
      .filter((item: SelectorItemDatatype) => item.type === filterType || filterType === SELECTOR_ITEM_TYPES.ALL)
      .filter(
        (item: SelectorItemDatatype) =>
          !filterKeyword ||
          item.name?.toLowerCase().includes(filterKeyword.toLowerCase()) ||
          item.description?.toLowerCase().includes(filterKeyword.toLowerCase())
      );
    setItems(allItems);
  }, [communities, competitors, filterType, filterKeyword]);

  return (
    <Container className={classNames({ empty: items.length == 0 }, 'mini-scroll')}>
      {items.length === 0 && <SidebarSelectorDropdownListEmptyState />}
      {items.map((entry: SelectorItemDatatype) => (
        <SidebarSelectorDropdownListItem key={entry.type + entry.id} item={entry} />
      ))}
    </Container>
  );
};

export default SidebarSelectorDropdownListUser;
